import { render } from "./PatientSheet.vue?vue&type=template&id=346be17c"
import script from "./PatientSheet.vue?vue&type=script&lang=ts"
export * from "./PatientSheet.vue?vue&type=script&lang=ts"
script.render = render

export default script